import axios, { type AxiosResponse } from "axios";
import { ProductItemSchema, ProductReviewItemSchema } from "@/schemas/index";
import type { ProductItemType, ProductReviewItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceProductsApiType {
  fetchPreviewProducts: (count?: number) => Promise<ProductItemType[]>;
  fetchProducts: () => Promise<ProductItemType[]>;
  fetchProductFromParamUrl: (
    paramUrl: ProductItemType["Url"],
  ) => Promise<ProductItemType>;
  fetchProductRecommendedList: (
    paramUrl: ProductItemType["Url"],
  ) => Promise<ProductItemType[]>;
  fetchProductRequiredList: (
    paramUrl: ProductItemType["Url"],
  ) => Promise<ProductItemType[]>;
  fetchProductReviewsList: (
    paramUrl: ProductItemType["Url"],
  ) => Promise<ProductReviewItemType[]>;
  fetchUpdateProductReview: (
    productReview: ProductReviewItemType,
  ) => Promise<ProductReviewItemType>;
}

export const serviceProductsApi: ServiceProductsApiType = {
  fetchProducts: () => {
    return axios
      .get(`${env.services.portal}/products`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            ProductItemSchema.parse(record),
          ) || []
        );
      });
  },
  fetchPreviewProducts: (count?: number) => {
    return axios
      .get(`${env.services.portal}/products-random?qty=${count || 8}`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            ProductItemSchema.parse(record),
          ) || []
        );
      });
  },
  fetchProductFromParamUrl: (paramUrl) => {
    return axios
      .get(`${env.services.portal}/products/${paramUrl}`)
      .then((response: AxiosResponse<unknown>) => {
        return ProductItemSchema.parse(response.data);
      });
  },
  fetchProductRecommendedList: (productId) => {
    return axios
      .get(`${env.services.portal}/products/${productId}/recommended`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            ProductItemSchema.parse(record),
          ) || []
        );
      });
  },
  fetchProductRequiredList: (productId) => {
    return axios
      .get(`${env.services.portal}/products/${productId}/required`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            ProductItemSchema.parse(record),
          ) || []
        );
      });
  },
  fetchProductReviewsList: (productId) => {
    return axios
      .get(`${env.services.portal}/products/${productId}/reviews`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            ProductReviewItemSchema.parse(record),
          ) || []
        );
      });
  },
  fetchUpdateProductReview: (productReview) => {
    return axios
      .post(
        `${env.services.portal}/products/${productReview.ProductId}/reviews`,
        ProductReviewItemSchema.parse(productReview),
      )
      .then((response: AxiosResponse<unknown>) => {
        return ProductReviewItemSchema.parse(response.data || {});
      });
  },
};
